import React__default from 'react';
import menuStyles from '../NewMenu.js';
import '../../LoadingSpinner/index.js';
import LoadingSpinner from '../../LoadingSpinner/LoadingSpinner.js';

const MenuSpinner = /*#__PURE__*/React__default.forwardRef((_, ref) => /*#__PURE__*/React__default.createElement(LoadingSpinner, {
  ref: ref,
  className: menuStyles.menuSpinner,
  show: true,
  size: "small",
  role: "menuitem"
}));

export { MenuSpinner as default };
